import React, { Component }  from 'react';
import { Radio } from 'antd';
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;


class NewRadio extends Component {
    // 段落个数发生变化
    onChange = e => {
        const { onOptionChange } = this.props;
        onOptionChange && onOptionChange(e.target.value);
    }
    renderData = () => {
        const { optionNum, maxOptionNum } = this.props;
        let numArr = [];
        for ( let i = 1; i <= maxOptionNum; i++) {
            numArr.push(<RadioButton key={i} value={i}>{i}</RadioButton>);
        }
        
        return (
            <RadioGroup onChange={this.onChange} value={optionNum}>
                {numArr}
            </RadioGroup>
        )  
    }
    render() {
        return (
            this.renderData()   
        )
    }
}

export default NewRadio;




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/components/radio.js